import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--receipts"
export default class extends Controller {
  static targets = [
    "receiptsForm"
  ]

  connect() {
  }

  submit(event) {
    event.preventDefault()

    event.currentTarget.disabled = true
    this.receiptsFormTarget.requestSubmit()
  }
}
